// extracted by mini-css-extract-plugin
export default {"badge":"NowStepsBadge_badge__SIZBu","ready":"NowStepsBadge_ready__Valhm","count":"NowStepsBadge_count__YXsMg","menu":"NowStepsBadge_menu__Vcz9b","title":"NowStepsBadge_title__apu0w"};